export class PagedResult<t> {
  search: string;
  limit: number;
  page: number;
  count: number;
  data: t[];
}
